module.exports = __webpack_public_path__ + "static/img/3.41a4e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/3.png
// module id = HwQ+
// module chunks = 1